import useSWR from 'swr'

import { handleErrors } from '../error-handling'

const fetcher = async (...args) => {
  const response = await fetch(...args)

  return handleErrors(response)
}

function useGetData(url) {
  const { data, error } = useSWR(url, fetcher)

  return {
    data,
    isLoading: !error && !data,
    isError: error,
  }
}

export default useGetData
